'use client'
import React, { useState } from 'react'

import { useSectionParams } from '@/_i18n/section-params'
import { IPreventiveExaminationComparison } from '@/_types'

const APreventiveExaminationsComparison = ({
	preventiveExaminationComparisonArray
}: {
	preventiveExaminationComparisonArray: IPreventiveExaminationComparison[]
}) => {
	const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>({})
	const { getSectionParams } = useSectionParams('preventiveExaminations')

	const toggleSection = (sectionId: string) => {
		setExpandedSections(prev => ({
			...prev,
			[sectionId]: !prev[sectionId]
		}))
	}

	return (
		<div className='wrapper' id={getSectionParams('preventiveExaminationProgramsComparison')}>
			<div className='mgt-0'>
				<div className='anim_delay anim_drop1 observe'>
					<h2 className='title_h1'>Porovnanie programov</h2>
				</div>
				<div className='dflex justify-between mgt-60 align-start flex-wrap flex-nowrap-lg'>
					{preventiveExaminationComparisonArray.map(preventiveExaminationComparison => (
						<div
							key={preventiveExaminationComparison.name}
							className={`item_compare ${
								preventiveExaminationComparison.name === 'services' ? 'left' : ''
							}`}
						>
							<div
								className='item_compare_title select-none'
								onClick={() =>
									toggleSection(preventiveExaminationComparison.id.toString())
								}
								style={{ cursor: 'pointer' }}
							>
								<h3 className='title_h3'>{preventiveExaminationComparison.name}</h3>
							</div>
							<div className='item_compare_title justify-center bordr'>
								<span>Basic</span>
							</div>
							<div className='item_compare_title justify-center bordr'>
								<span>Optimal</span>
							</div>
							<div className='item_compare_title justify-center'>
								<span>Complex</span>
							</div>

							{preventiveExaminationComparison.parameters
								.slice(
									0,
									expandedSections[preventiveExaminationComparison.id.toString()]
										? undefined
										: 5
								)
								.map((item, index) => (
									<React.Fragment key={index}>
										<div
											className={`item_compare_body ${
												index === 0 ? 'first' : ''
											} `}
										>
											{item.name}
										</div>
										{item.values.map((value, index) => (
											<div className={`item_compare_body bordr`} key={index}>
												{item.type !== 'Boolean'
													? value.value
													: value.value && (
															<img
																src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/icons/ok.png`}
																alt='✓'
															/>
														)}
											</div>
										))}
									</React.Fragment>
								))}

							<button
								title='Porovnanie programov'
								onClick={e => {
									e.preventDefault()
									toggleSection(preventiveExaminationComparison.id.toString())
								}}
								className={`btn_section-down down type1 ${
									expandedSections[preventiveExaminationComparison.id.toString()]
										? 'hidden'
										: ''
								}`}
								style={{
									display: expandedSections[
										preventiveExaminationComparison.id.toString()
									]
										? 'none'
										: 'block'
								}}
							>
								<span>
									<svg className='sico'>
										<use href='/assets/layout/icons.svg#s_ar1_d' />
									</svg>
								</span>
							</button>

							<button
								title='Porovnanie programov'
								onClick={() =>
									toggleSection(preventiveExaminationComparison.id.toString())
								}
								className={`btn_section-down type1 up ${
									!expandedSections[preventiveExaminationComparison.id.toString()]
										? 'hidden'
										: ''
								}`}
								style={{
									display: !expandedSections[
										preventiveExaminationComparison.id.toString()
									]
										? 'none'
										: 'block'
								}}
							>
								<span>
									<svg className='sico'>
										<use href='/assets/layout/icons.svg#s_ar1_u' />
									</svg>
								</span>
							</button>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}

export default APreventiveExaminationsComparison
// {
// 	Object.entries(comparisonData).map(([key, section]) => (
// 		<div key={key} className={`item_compare ${key === 'services' ? 'left' : ''}`}>
// 			<div
// 				className='item_compare_title select-none'
// 				onClick={() => handleTitleClick(key)}
// 				style={{ cursor: 'pointer' }}
// 			>
// 				<h3 className='title_h3'>{section.title}</h3>
// 			</div>
// 			<div className='item_compare_title justify-center bordr'>
// 				<span>Basic</span>
// 			</div>
// 			<div className='item_compare_title justify-center bordr'>
// 				<span>Optimal</span>
// 			</div>
// 			<div className='item_compare_title justify-center'>
// 				<span>Complex</span>
// 			</div>

// 			{section.items.map((item, index) => (
// 				<React.Fragment key={index}>
// 					<div
// 						className={`item_compare_body ${index === 0 ? 'first' : ''} ${
// 							index === section.items.length - 1 && !expandedSections[key]
// 								? 'last-show'
// 								: ''
// 						}`}
// 						style={{
// 							display: index >= 5 && !expandedSections[key] ? 'none' : 'block'
// 						}}
// 					>
// 						{item.name}
// 						{item.description && <p>{item.description}</p>}
// 					</div>
// 					<div
// 						className={`item_compare_body ${index === 0 ? 'first' : ''} ${
// 							index === section.items.length - 1 && !expandedSections[key]
// 								? 'last-show'
// 								: ''
// 						} bordr`}
// 						style={{
// 							display: index >= 5 && !expandedSections[key] ? 'none' : 'block'
// 						}}
// 					>
// 						{item.basic && <img src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/icons/ok.png`} alt='✓' />}
// 					</div>
// 					<div
// 						className={`item_compare_body ${index === 0 ? 'first' : ''} ${
// 							index === section.items.length - 1 && !expandedSections[key]
// 								? 'last-show'
// 								: ''
// 						} bordr`}
// 						style={{
// 							display: index >= 5 && !expandedSections[key] ? 'none' : 'block'
// 						}}
// 					>
// 						{item.optimal && <img src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/icons/ok.png`} alt='✓' />}
// 					</div>
// 					<div
// 						className={`item_compare_body ${index === 0 ? 'first' : ''} ${
// 							index === section.items.length - 1 && !expandedSections[key]
// 								? 'last-show'
// 								: ''
// 						}`}
// 						style={{
// 							display: index >= 5 && !expandedSections[key] ? 'none' : 'block'
// 						}}
// 					>
// 						{item.complex && <img src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/icons/ok.png`} alt='✓' />}
// 					</div>
// 				</React.Fragment>
// 			))}

// 			<Link
// 				href='#'
// 				title='Porovnanie programov'
// 				onClick={e => {
// 					e.preventDefault()
// 					toggleSection(key)
// 				}}
// 				className={`btn_section-down down type1 ${expandedSections[key] ? 'hidden' : ''}`}
// 				style={{ display: expandedSections[key] ? 'none' : 'block' }}
// 			>
// 				<span>
// 					<svg className='sico'>
// 						<use href='/assets/layout/icons.svg#s_ar1_d' />
// 					</svg>
// 				</span>
// 			</Link>

// 			<Link
// 				href='#'
// 				title='Porovnanie programov'
// 				onClick={() => toggleSection(key)}
// 				className={`btn_section-down type1 up ${!expandedSections[key] ? 'hidden' : ''}`}
// 				style={{ display: !expandedSections[key] ? 'none' : 'block' }}
// 			>
// 				<span>
// 					<svg className='sico'>
// 						<use href='/assets/layout/icons.svg#s_ar1_u' />
// 					</svg>
// 				</span>
// 			</Link>
// 		</div>
// 	))
// }
